<template>
  <div>
    <div class="page-title">Edit Notification</div>
    <Form v-if="form" btnText="Update Notification" :submit="update" v-model="form" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.profile_notification.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setNotification();
  },
  methods: {
    async update() {
      await this.$api.ProfileNotification.update(this.form);
      this.$router.push("/profile_notifications");
    },
    async setNotification() {
      const { data } = await this.$api.ProfileNotification.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
